import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Badge,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import SyncIcon from '@mui/icons-material/Sync';
import RestoreIcon from '@mui/icons-material/Restore';
import { BulkSyncDialog } from './BulkSyncDialog';

interface AdminAgentToolbarProps {
  pendingUpdatesCount?: number;
}

export const AdminAgentToolbar: React.FC<AdminAgentToolbarProps> = ({
  pendingUpdatesCount = 0,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [syncDialogOpen, setSyncDialogOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSyncAll = () => {
    setSyncDialogOpen(true);
    handleClose();
  };

  return (
    <>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'admin-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Badge badgeContent={pendingUpdatesCount} color="warning">
            <SettingsIcon />
          </Badge>
        </IconButton>

      <Menu
        anchorEl={anchorEl}
        id="admin-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleSyncAll}>
          <ListItemIcon>
            <SyncIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Sync All Agents"
            secondary={
              pendingUpdatesCount > 0
                ? `${pendingUpdatesCount} agent(s) need update`
                : 'Push template updates'
            }
          />
        </MenuItem>

        <Divider />

        <MenuItem disabled>
          <ListItemIcon>
            <RestoreIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Reset All (Coming Soon)"
            secondary="Reset all agents to defaults"
          />
        </MenuItem>
      </Menu>

      <BulkSyncDialog
        open={syncDialogOpen}
        onClose={() => setSyncDialogOpen(false)}
        agentType="AI_SYSTEM_BUILDER"
      />
    </>
  );
};
